import { createI18n } from 'vue-i18n';
import deAT from './locales/de-AT.json';
import en from './locales/en.json';
import { teacherExamsMessages } from './modules/teacher-exams/locales';
import { teacherGradingMessages } from './modules/teacher-grading/locales';
import { auditLocales } from './modules/audit/locales';
import { configAdminLocales } from './modules/config-admin/locales';
import { gdprAdminLocales } from './modules/gdpr-admin/locales';
import { emailOutboxLocales } from './modules/email-outbox/locales';

type MessageSchema = typeof deAT;

const i18n = createI18n<[MessageSchema], 'de-AT' | 'en'>({
  legacy: false,
  locale: 'de-AT',
  fallbackLocale: 'en',
  messages: {
    'de-AT': deAT,
    en,
  },
});

// Merge module-local message bundles. Kept out of locales/*.json to keep
// module self-containment (see CLAUDE.md: "Locales → modules/<domain>/locales.ts").
for (const pack of [
  teacherExamsMessages,
  teacherGradingMessages,
  auditLocales,
  configAdminLocales,
  gdprAdminLocales,
  emailOutboxLocales,
]) {
  for (const [locale, messages] of Object.entries(pack)) {
    i18n.global.mergeLocaleMessage(locale, messages);
  }
}

export default i18n;
